import React, { useEffect, useState, useReducer, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import FetchUtil from "../../utils/FetchUtil";
import { useTranslation } from 'react-i18next';
import { useTable, useSortBy, usePagination } from "react-table";
import Select from 'react-select';
import EventDetail from "./EventDetail";
import UserContext from "../../contexts/UserContext";
import Header from "../Navigation/Header";

let typeOptions = [];
let harmLocOptions = [];
let origLocOptions = [];
let motivationOptions = [];
let harmOptions = [];
let categoryOptions = [];
let adulterationOptions = [];

const selectStyles = {
	control: styles => ({
		...styles, backgroundColor: 'white', borderRadius: '10px',
		lineHeight: '25px', minHeight: '26px', height: '30px', fontSize: '14px', verticalAlign: 'middle'
	}),
	option: (styles, state) => {
		return {
			...styles,
			lineHeight: '25px', height: '30px', fontSize: '14px',
			fontWeight: state.isSelected ? "bold" : "normal",
			whiteSpace: "nowrap",
			textOverflow: "ellipsis",
		};
	},
	singleValue: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '14px', marginTop: '0px', marginBottom: '16px',
	}),
	indicatorSeparator: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '26px', fontSize: '14px', marginTop: '0px',
	}),
	indicatorContainer: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '26px', fontSize: '14px', marginTop: '0px',
	}),
	indicatorsContainer: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '26px', fontSize: '14px', marginTop: '0px',
	}),
	container: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '14px', maxWidth: '25vw', whiteSpace: 'nowrap',
	}),
	input: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '26px', fontSize: '14px', marginTop: '0px', marginBottom: '16px',
	}),
	placeholder: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '26px', fontSize: '14px', marginTop: '0px',
	}),
}

const initialState = {
	queryPageIndex: 0,
	queryPageSize: 25,
	totalCount: 0,
	currentData: [],
};

const PAGE_CHANGED = 'PAGE_CHANGED';
const TOTAL_COUNT_CHANGED = 'TOTAL_COUNT_CHANGED';

const reducer = (state, { type, payload, data, t }) => {
	switch (type) {
		case PAGE_CHANGED:
			return {
				...state,
				queryPageIndex: payload,
				currentData: data
			};
		case TOTAL_COUNT_CHANGED:
			return {
				...state,
				totalCount: payload,
				currentData: data
			};
		default:
			return {
				...state,
				...initialState
			};
	}
};

let pageData = [];
function setPageData(pageDataList) {
	pageData = pageDataList;
}
const defIncidentText = "Select Type of Incident";
const defHarmText = "Select Harm Location";
const defMotivationText = "Select Motivation";
const defOriginatedText = "Select Originated Location";
const defIncidentHarmText = "Select Type of Harm";
const defFoodCategoryText = "Select Food Category";
const defAdulterationText = "Select Method of Adulteration";

function SearchEvent() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const userCtx = useContext(UserContext);
	const [errorValue, setErrorValue] = useState(null);
	const [isSearching, setIsSearching] = useState(false);
	const [showAdvanced, setShowAdvanced] = useState(false);
	const [showDetails, setShowDetails] = useState(false);


	const [{ queryPageIndex, queryPageSize, totalCount, currentData }, dispatch] =
		useReducer(reducer, initialState);
	const columns = React.useMemo(
		() => [
			{
				id: 'row_foodCategory',
				accessor: 'row_foodCategory',
				Header: () => t("page.foodCat"),
				minWidth: '15%',
				width: '16%',
			},
			{
				accessor: 'row_yearBegan',
				Header: () => t("page.yearBegan"),
				minWidth: '5%',
				width: '9%',
			},
			{
				accessor: 'row_yearEnded',
				Header: () => t("page.yearEnded"),
				minWidth: '5%',
				width: '9%',
			},
			{
				accessor: 'row_adulteratedFoods',
				Header: () => t("page.aduFoodProd"),
				minWidth: '15%',
				width: '16%',
			},
			{
				accessor: 'row_adulterants',
				Header: () => t("page.adulterant"),
				minWidth: '13%',
				width: '13%',
			},
			{
				accessor: 'row_adulterations',
				Header: () => t("page.methodAdu"),
				minWidth: '15%',
				width: '16%',
			},

			{
				accessor: 'rows_originLocations',
				Header: () => t("page.origLoc"),
				minWidth: '15%',
				width: '16%',
			},
			{
				accessor: 'rows_action',
				id: 'rows_action',
				Header: () => t("page.action"),
				minWidth: '5%',
				disableSortBy: true,
				Cell: ({ row }) => (
					<div>
						<button className="btn btn-primary btn-block me-2" data-toggle="modal" data-target="#eventModal" onClick={e => handleOpenClick(e, row.original)}>{t("page.open")}</button>
					</div>
				),
				footer: props => props.column.id,
			},
		],
		[]
	)

	const initialValues = {
		row_foodCategory: "",
		row_yearBegan: 0,
		row_yearEnded: 0,
		row_adulteratedFoods: "",
		row_adulterants: "",
		row_adulterations: "",
		rows_originLocations: "",
		rows_action: 0,
		id: 0,
		yearBegan: 0,
		yearEnded: 0,
		descriptionOfHarm: "",
		incidentSummary: "",
		numberOfReferences: 0,
		morbidityRange: "",
		mortalityRange: "",
		adulterationName: "",
		typeName: "",
		quantityOfAdulterantUsed: "",
		longTermImpact: "",
		history: "",
		descriptionOfMotivation: "",
		pointOfIntroductionDescription: "",
		volumeOfProductAdulterated: "",
		foodCategories: [],
		adulteratedFoods: [],
		affectedFoods: [],
		adulterants: [],
		adulterations: [],
		originatedLocations: [],
		citations: [],
		pointOfIntroductions: [],
		harms: [],
		harmLocations: [],
		motivations: [],
		brands: [],

	};
	const [eventDataSelected, setEventDataSelected] = useState({});
	const [count, setCount] = useState(0);


	const [searchText, setSearchText] = useState("");
	const [incidentType, setIncidentType] = useState({ name: "incidentType", label: defIncidentText, value: "0" });
	const [harmLocation, setHarmLocation] = useState({ name: "harmLocation", label: defHarmText, value: "0" });
	const [motivation, setMotivation] = useState({ name: "motivation", label: defMotivationText, value: "0" });
	const [originatedLocation, setOriginatedLocation] = useState({ name: "originatedLocation", label: defOriginatedText, value: "0" });
	const [incidentHarm, setIncidentHarm] = useState({ name: "incidentHarm", label: defIncidentHarmText, value: "0" });
	const [foodCategory, setFoodCategory] = useState({ name: "foodCategory", label: defFoodCategoryText, value: "0" });
	const [adulteration, setAdulteration] = useState({ name: "adulteration", label: defAdulterationText, value: "0" });

	useEffect(() => {
		if (!userCtx.isAuthenticated) {
			navigate("/");
		}
		fetchSearchParam();
	}, []);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		nextPage,
		previousPage,
		prepareRow,
		page,
		canPreviousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		// Get the state from the instance
		state: { pageIndex, pageSize },
	} = useTable({
		columns: columns, data: pageData,
		initialState: {
			pageIndex: queryPageIndex,
			pageSize: queryPageSize,
			sortBy: [
				{
					id: 'row_foodCategory',
					desc: false
				}
			]
		},

	}, useSortBy, usePagination);

	useEffect(() => {
		dispatch({
			type: TOTAL_COUNT_CHANGED,
			payload: count,
			data: (pageData && pageData.length > 0) ? pageData : [],
			t: t
		});
		gotoPage(0);
	}, [count, gotoPage]);

	function setTypeValues(typeObj) {
		let typeValue = {};
		typeOptions = [];
		typeOptions.push({ label: defIncidentText, value: "0" });
		if (typeObj && typeObj.length > 0) {
			typeObj.map((info, index) => {
				typeValue.label = info.name;
				typeValue.value = info.id;
				typeOptions.push(typeValue);
				typeValue = {};
			});
		}
	}
	function setLocationValues(locObj) {
		let locValue = {};
		harmLocOptions = [];
		harmLocOptions.push({ label: defHarmText, value: "0" });
		origLocOptions = [];
		origLocOptions.push({ label: defOriginatedText, value: "0" });
		if (locObj && locObj.length > 0) {
			locObj.map((info, index) => {
				locValue.label = info.name;
				locValue.value = info.id;
				harmLocOptions.push(locValue);
				origLocOptions.push(locValue);
				locValue = {};
			});
		}
	}
	function setMotivationValues(motiveObj) {
		let motiveValue = {};
		motivationOptions = [];
		motivationOptions.push({ label: defMotivationText, value: "0" });
		if (motiveObj && motiveObj.length > 0) {
			motiveObj.map((info, index) => {
				motiveValue.label = info.name;
				motiveValue.value = info.id;
				motivationOptions.push(motiveValue);
				motiveValue = {};
			});
		}
	}
	function setHarmValues(harmObj) {
		let harmValue = {};
		harmOptions = [];
		harmOptions.push({ label: defIncidentHarmText, value: "0" });
		if (harmObj && harmObj.length > 0) {
			harmObj.map((info, index) => {
				harmValue.label = info.name;
				harmValue.value = info.id;
				harmOptions.push(harmValue);
				harmValue = {};
			});
		}
	}
	function setCategoryValues(categoryObj) {
		let categoryValue = {};
		categoryOptions = [];
		categoryOptions.push({ label: defFoodCategoryText, value: "0" });
		if (categoryObj && categoryObj.length > 0) {
			categoryObj.map((info, index) => {
				categoryValue.label = info.name;
				categoryValue.value = info.id;
				categoryOptions.push(categoryValue);
				categoryValue = {};
			});
		}
	}
	function setAdulterationValues(adulterationObj) {
		let adulterationValue = {};
		adulterationOptions = [];
		adulterationOptions.push({ label: defAdulterationText, value: "0" });
		if (adulterationObj && adulterationObj.length > 0) {
			adulterationObj.map((info, index) => {
				adulterationValue.label = info.name;
				adulterationValue.value = info.id;
				adulterationOptions.push(adulterationValue);
				adulterationValue = {};
			});
		}
	}
	function fetchSearchParam() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web" }),
		};
		try {
			FetchUtil.fetchAPI("GetSearchParam", "/Service/Search/GetSearchParam", requestOptions, getParamSuccess, getParamFail);
		} catch (error) {
			setErrorValue(error.message);
		}
	}

	function getParamFail(redirect) {
		setErrorValue(t("error.getParamFailed"));
		if (redirect) {
			navigate("/");
		}
	}

	function getParamSuccess(responseData) {
		var getSearchParamResponse;
		if (responseData) {
			getSearchParamResponse = responseData.getSearchParamResponse;
			if (getSearchParamResponse && getSearchParamResponse.errorCode === "0") {
				setTypeValues(getSearchParamResponse.types);
				setLocationValues(getSearchParamResponse.countries);
				setMotivationValues(getSearchParamResponse.motivations);
				setHarmValues(getSearchParamResponse.harms);
				setCategoryValues(getSearchParamResponse.foodCategories);
				setAdulterationValues(getSearchParamResponse.adulterations);
			} else if (getSearchParamResponse) {
				setErrorValue(t("error.error") + " " + getSearchParamResponse.errorMessage);
			}
		}
	}

	function searchEvent() {
		setCount(0);
		var searchObj = { source: "web", searchText: searchText };
		if (incidentType.value && incidentType.value !== "0") {
			searchObj[incidentType.name] = incidentType.label;
		}
		if (harmLocation.value && harmLocation.value !== "0") {
			searchObj[harmLocation.name] = harmLocation.label;
		}
		if (motivation.value && motivation.value !== "0") {
			searchObj[motivation.name] = motivation.label;
		}
		if (originatedLocation.value && originatedLocation.value !== "0") {
			searchObj[originatedLocation.name] = originatedLocation.label;
		}
		if (incidentHarm.value && incidentHarm.value !== "0") {
			searchObj[incidentHarm.name] = incidentHarm.label;
		}
		if (foodCategory.value && foodCategory.value !== "0") {
			searchObj[foodCategory.name] = foodCategory.label;
		}
		if (adulteration.value && adulteration.value !== "0") {
			searchObj[adulteration.name] = adulteration.label;
		}


		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(searchObj),
		};
		try {
			FetchUtil.fetchAPI("SearchEvent", "/Service/Search/SearchEvent", requestOptions, searchSuccess, searchFail);
		} catch (error) {
			setErrorValue(error.message);
			setIsSearching(false);
		}
	}

	function searchFail(redirect) {
		setErrorValue(t("error.searchFailed"));
		setIsSearching(false);
		setPageData([]);
		setCount(0);
		if (redirect) {
			navigate("/");
		}
	}

	function searchSuccess(responseData) {
		var searchEventResponse;
		if (responseData) {
			searchEventResponse = responseData.searchEventResponse;
			if (searchEventResponse && searchEventResponse.errorCode === "0") {
				setSearchResult(searchEventResponse.events);

			} else if (searchEventResponse) {
				setErrorValue(t("error.error") + " " + searchEventResponse.errorMessage);
				setPageData([]);
				setCount(0);
			}
		}
		setIsSearching(false);
	}

	function setSearchResult(eventObj) {
		generateTableData(eventObj);
		//setEvents(eventObj);
	}
	function generateTableData(eventObj) {
		if (eventObj && eventObj.length > 0) {
			const result = [];
			eventObj.map(function(data) {
				let foodCategories = data.foodCategories.map(function(foodCategory) {
					return foodCategory.name;
				});
				let adulteratedProducts = data.adulteratedFoods.map(function(foodProduct) {
					return foodProduct.name;
				});
				let adulterants = data.adulterants.map(function(adulterant) {
					return adulterant.name;
				});
				/*let adulterations = data.adulterations.map(function(adulteration) {
					return adulteration.name;
				});*/
				let adulterations = [];
				adulterations.push(data.adulterationName);

				let locations = data.originatedLocations.map(function(originatedLocation) {
					return originatedLocation.regionName + ", " + originatedLocation.name + (originatedLocation.state ? ", " + originatedLocation.state : "") + (originatedLocation.city ? ", " + originatedLocation.city : "");
				});
				let aData = {
					...initialValues, ...data, row_foodCategory: foodCategories.join(', '), row_yearBegan: data.yearBegan,
					row_yearEnded: data.yearEnded, row_adulteratedFoods: adulteratedProducts.join('; '),
					row_adulterants: adulterants.join('; '), row_adulterations: adulterations.join('; '), rows_originLocations: locations.join('; ')
				};
				result.push(aData);
			}

			);

			setPageData(result);
			setCount(eventObj.length);
		} else {
			setPageData([]);
			setCount(0);
		}
	}
	const onKeywordChange = (e) => {
		setErrorValue("");
		const { name, value } = e.target;
		//console.log(name + "  " + value);
		setSearchText(value);
	}
	const handleSelectChange = (selectedOption, action) => {
		let value = selectedOption ? selectedOption.value : "0";
		let label = selectedOption ? selectedOption.label : "";
		let name = action.name;
		//console.log(name + "  " + value + " " + label);
		switch (name) {
			case 'incidentType':
				//console.log("set incidentType " + value);
				setIncidentType({ ...incidentType, label: (label || defIncidentText), value: value });
				break;
			case 'harmLocation':
				setHarmLocation({ ...harmLocation, label: (label || defHarmText), value: value });
				break;
			case 'motivation':
				setMotivation({ ...motivation, label: (label || defMotivationText), value: value });
				break;
			case 'originatedLocation':
				setOriginatedLocation({ ...originatedLocation, label: (label || defOriginatedText), value: value });
				break;
			case 'incidentHarm':
				setIncidentHarm({ ...incidentHarm, label: (label || defIncidentHarmText), value: value });
				break;
			case 'foodCategory':
				setFoodCategory({ ...foodCategory, label: (label || defFoodCategoryText), value: value });
				break;
			case 'adulteration':
				setAdulteration({ ...adulteration, label: (label || defAdulterationText), value: value });
				break;
			default:
			// code block
		}

	};
	const onClickSearch = () => {

		let searchTextInput = searchText ? searchText.trim() : "";
		if ((!searchTextInput || searchTextInput.length < 3) && incidentType.value === "0" &&
			harmLocation.value === "0" && motivation.value === "0" && originatedLocation.value === "0" &&
			incidentHarm.value === "0" && foodCategory.value === "0" && adulteration.value === "0") {
			setErrorValue(t("error.minSearchParam"));
			return;
		}
		setErrorValue("");
		setSearchResult([]);
		setIsSearching(true);
		searchEvent();
	}
	const onClickClear = () => {
		setErrorValue("");
		setSearchText("");
		setIncidentType({ ...incidentType, label: defIncidentText, value: "0" });
		setHarmLocation({ ...harmLocation, label: defHarmText, value: "0" });
		setMotivation({ ...motivation, label: defMotivationText, value: "0" });
		setOriginatedLocation({ ...originatedLocation, label: defOriginatedText, value: "0" });
		setIncidentHarm({ ...incidentHarm, label: defIncidentHarmText, value: "0" });
		setFoodCategory({ ...foodCategory, label: defFoodCategoryText, value: "0" });
		setAdulteration({ ...adulteration, label: defAdulterationText, value: "0" });
		setSearchResult([]);
	}
	const onClickAdvanced = () => {
		if (showAdvanced) {
			// hide so reset
			setIncidentType({ ...incidentType, label: defIncidentText, value: "0" });
			setHarmLocation({ ...harmLocation, label: defHarmText, value: "0" });
			setMotivation({ ...motivation, label: defMotivationText, value: "0" });
			setOriginatedLocation({ ...originatedLocation, label: defOriginatedText, value: "0" });
			setIncidentHarm({ ...incidentHarm, label: defIncidentHarmText, value: "0" });
			setFoodCategory({ ...foodCategory, label: defFoodCategoryText, value: "0" });
			setAdulteration({ ...adulteration, label: defAdulterationText, value: "0" });
		}
		setShowAdvanced(!showAdvanced);
	}



	const handleOpenClick = (event, eventData) => {
		event.preventDefault();
		event.stopPropagation();
		setErrorValue("");
		let eventDataMap = JSON.parse(JSON.stringify(eventData));
		//console.log(eventDataMap);
		setEventDataSelected({ ...initialValues, ...eventDataMap });
		setShowDetails(true);
		window.scrollTo({ top: '15vh', behavior: 'smooth' });
	};

	return (
		<div className="container-fluid">
			<Header />
			<div id="page" className={showDetails ? "container-fluid container_list pe-none" : "container-fluid container_list"}>
				{(errorValue) && (
					<>
						<div className="row">
							<div className="col">
								<div id="inerrorMessage" className="errorblock">
									{errorValue}
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div id="placeholder_1" className="placeholder-pg"></div>
							</div>
						</div>
					</>
				)}
				<div className="search-group">
					<div className="form-group search-box">
						<input
							id="searchData"
							name="searchText"
							onChange={onKeywordChange}
							value={searchText}
							type="text"
							placeholder="Search here..."
							className="search-text"
						/>
					</div>
					{showAdvanced &&
						<div className="page-filterdd">
							<div className="row row-space">
								<div className="col-3" style={{ paddingLeft: "0px" }}>
									<Select
										name="incidentType"
										options={typeOptions}
										onChange={handleSelectChange}
										placeholder={defIncidentText}
										value={incidentType}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="incidentType-input"
										styles={selectStyles}
									/>
								</div>
								<div className="col-3">
									<Select
										name="harmLocation"
										options={harmLocOptions}
										onChange={handleSelectChange}
										placeholder={defHarmText}
										value={harmLocation}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="harmLocation-input"
										styles={selectStyles}
									/>
								</div>
								<div className="col-3">
									<Select
										name="motivation"
										options={motivationOptions}
										onChange={handleSelectChange}
										placeholder={defMotivationText}
										value={motivation}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="motivation-input"
										styles={selectStyles}
									/>
								</div>
								<div className="col-3">
									<Select
										name="originatedLocation"
										options={origLocOptions}
										onChange={handleSelectChange}
										placeholder={defOriginatedText}
										value={originatedLocation}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="originatedLocation-input"
										styles={selectStyles}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-3" style={{ paddingLeft: "0px" }}>
									<Select
										name="incidentHarm"
										options={harmOptions}
										onChange={handleSelectChange}
										placeholder={defIncidentHarmText}
										value={incidentHarm}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="incidentHarm-input"
										styles={selectStyles}
									/>
								</div>
								<div className="col-3">
									<Select
										name="foodCategory"
										options={categoryOptions}
										onChange={handleSelectChange}
										placeholder={defFoodCategoryText}
										value={foodCategory}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="foodCategory-input"
										styles={selectStyles}
									/>
								</div>
								<div className="col-3">
									<Select
										name="adulteration"
										options={adulterationOptions}
										onChange={handleSelectChange}
										placeholder={defAdulterationText}
										value={adulteration}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="adulteration-input"
										styles={selectStyles}
									/>
								</div>
								<div className="col-3">

								</div>
							</div>
						</div>
					}
					<div className="form-group search-button-box">
						<div id="submit-spinner"
							className={isSearching ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
						>  </div>
						<button
							type="submit"
							className="btn btn-primary btn-block search-button"
							onClick={onClickSearch}
							disabled={isSearching}
						>
							<span class="fa fa-search fa-2">{' '}</span>{t("page.search")}
						</button>

						<button
							type="submit"
							className="btn btn-primary btn-block search-button"
							onClick={onClickAdvanced}
							disabled={isSearching}
						>{t("page.advancedsearch")}
						</button>

						<button className="btn btn-primary btn-block search-clear" onClick={onClickClear} disabled={isSearching} >{t("page.clear")}
						</button>
					</div>
				</div>
				<br />
				<div className="row">
					<div className="col">
						{(
							<>
								<table className="list-table" {...getTableProps()}>
									<thead>

										{headerGroups.map(headerGroup => (
											<tr {...headerGroup.getHeaderGroupProps()}>
												{headerGroup.headers.map(column => (
													<th {...column.getHeaderProps(column.getSortByToggleProps())} className="list-th">
														{column.render("Header")}&nbsp;&nbsp;
														<span className={
															(count > 0 && column.canSort) ? column.isSorted
																? column.isSortedDesc
																	? "fa fa-sort-down"
																	: "fa fa-sort-up"
																: "fa fa-sort"
																: ""
														} style={{ fontSize: '24px', color: '#0c374c', float: 'right', verticalAlign: 'middle' }}>
														</span>
													</th>
												))}
											</tr>
										))}
									</thead>
									<tbody {...getTableBodyProps()}>
										{page.map((row, index) => {
											prepareRow(row);
											let oddIdx = ((index % 2) > 0) ? true : false;
											return (
												<tr	{...row.getRowProps()}>
													{row.cells.map((cell) => {
														return (
															<td
																{...cell.getCellProps()}
																className={oddIdx ? "list-td col odd" : "list-td col even"}
																style={{
																	minWidth: cell.column.minWidth,
																	width: cell.column.width,
																}}
															>
																{cell.render("Cell")}
															</td>
														);
													})}
												</tr>
											);

										})}
									</tbody>
								</table>

								<div className="pagination">
									<button className="nav-button" onClick={() => { gotoPage(0); }} disabled={!canPreviousPage}>
										{'<<'}
									</button>
									<button className="nav-button" onClick={() => { previousPage(); }} disabled={!canPreviousPage}>
										{'<'}
									</button>
									<button className="nav-button" onClick={() => { nextPage(); }} disabled={!canNextPage}>
										{'>'}
									</button>
									<button className="nav-button"
										onClick={() => { gotoPage(pageCount - 1); }}
										disabled={!canNextPage}
									>
										{'>>'}
									</button>
									<span className="nav-page-info">{t("page.page") + ' '}
										<strong>
											{pageOptions.length > 0 ? pageIndex + 1 : 0} {t("page.of")} {pageOptions.length}
										</strong>
									</span>
									<span className="nav-page-goto">{t("page.goToPage")}:{' '}
										<input
											type="number"
											value={pageIndex + 1}
											onChange={(e) => {
												const page = e.target.value ? Number(e.target.value) - 1 : 0;
												gotoPage(page);
											}}
											className="nav-goto-input"
										/>
									</span>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
			{showDetails && <EventDetail t={t} data={eventDataSelected} setShowDetails={setShowDetails} />}
		</div>
	);
}
export default SearchEvent;
